module.exports = __webpack_public_path__ + "static/img/180x180.90124ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/180x180.png
// module id = bV6a
// module chunks = 0